export enum TravelFrequency {
    DAILY = "Daily",
    WEEKLY = "Weekly",
    MONTHLY = "Monthly",
    QUARTERLY = "Quarterly",
    LESS_OFTEN_NEVER = "Less often / never"
}